<template>
  <markdown-viewer :title="title" :markdown-content-raw="markdownContentRaw" />
</template>

<script>
import MarkdownViewer from './markdown-viewer.vue';
import meetingsMarkdown from './markdown_docs/meetings.md?raw';

export default {
  name: 'MeetingsGuidance',
  components: {
    MarkdownViewer,
  },
  data() {
    return {
      title: 'Meetings on EDUKATE',
      markdownContentRaw: meetingsMarkdown,
    };
  },
};
</script>
